/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {finishWebAuthnRegistration} from '../api'

export const useMutationFinishWebAuthnRegistration = createReactQueryMutationHook('finishWebAuthnRegistration', finishWebAuthnRegistration)
